export var Tags;
(function (Tags) {
    Tags["browser"] = "Browser";
    Tags["node"] = "Node";
    Tags["typescript"] = "TypeScript";
    Tags["flow"] = "Flow";
    Tags["angular"] = "Angular";
    Tags["stencil"] = "Stencil";
    Tags["react"] = "React";
    Tags["vue"] = "Vue";
})(Tags || (Tags = {}));
//# sourceMappingURL=types.js.map